import React, { ReactNode } from 'react'
import * as Popover from '@radix-ui/react-popover'

interface PopOverProps {
  children: ReactNode
  trigger?: ReactNode
  isOpen?: boolean
  onOpenChange?: (a: boolean) => void
  onCloseClick?: () => void
  mainAction?: () => void
  align?: 'center' | 'start' | 'end' | undefined
  alignOffset?: number
  sideOffset?: number
}

export const PopOver = ({
  children,
  isOpen,
  onOpenChange,
  trigger,
  align,
  alignOffset,
  sideOffset,
}: PopOverProps) => {
  return (
    <Popover.Root open={isOpen} onOpenChange={onOpenChange}>
      {trigger}
      <Popover.Portal>
        <Popover.Content
          align={align || 'center'}
          alignOffset={alignOffset || 0}
          sideOffset={sideOffset || 0}
        >
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
